import defined from "../Core/defined.js";
import destroyObject from "../Core/destroyObject.js";

/**
 * @private
 */
function TextureCache() {
  this._textures = new Map();
  this._numberOfTextures = 0;
  this._texturesToRelease = new Map();
}

Object.defineProperties(TextureCache.prototype, {
  numberOfTextures: {
    get: function () {
      return this._numberOfTextures;
    },
  },
});

TextureCache.prototype.getTexture = function (keyword) {
  const cachedTexture = this._textures.get(keyword);
  if (!defined(cachedTexture)) {
    return undefined;
  }

  // No longer want to release this if it was previously released.
  this._texturesToRelease.delete(keyword);

  ++cachedTexture.count;
  return cachedTexture.texture;
};

TextureCache.prototype.addTexture = function (keyword, texture) {
  const cachedTexture = {
    texture: texture,
    count: 1,
  };

  texture.finalDestroy = texture.destroy;

  const that = this;
  texture.destroy = function () {
    if (--cachedTexture.count === 0) {
      that._texturesToRelease.set(keyword, cachedTexture);
    }
  };

  this._textures.set(keyword, cachedTexture);
  ++this._numberOfTextures;
};

TextureCache.prototype.destroyReleasedTextures = function () {
  const texturesToRelease = this._texturesToRelease;

  for (const [keyword, cachedTexture] of texturesToRelease) {
    this._textures.delete(keyword);
    cachedTexture.texture.finalDestroy();
    --this._numberOfTextures;
  }

  this._texturesToRelease.clear();
};

TextureCache.prototype.isDestroyed = function () {
  return false;
};

TextureCache.prototype.destroy = function () {
  const textures = this._textures;
  for (const [keyword, entry] of textures) {
    entry.texture.finalDestroy();
  }
  return destroyObject(this);
};
export default TextureCache;
